import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "clear", "results", "resultsText", "accordion", "category", "intake", "count"]

  connect() {
    this.totalCount = this.countTarget.textContent
  }

  search() {
    const query = this.inputTarget.value.toLowerCase().trim()
    
    // Show/hide clear button
    this.clearTarget.style.display = query ? 'flex' : 'none'
    
    if (!query) {
      this.resetSearch()
      return
    }

    let matchCount = 0
    let matchingCategories = 0

    this.categoryTargets.forEach(category => {
      const items = category.querySelectorAll('.event-item')
      const collapse = category.querySelector(':scope > .collapse')
      const header = category.querySelector('.evt-category-header')
      let categoryMatches = 0

      items.forEach(item => {
        const link = item.querySelector('.event-link')
        const text = link.textContent.toLowerCase()
        
        if (text.includes(query)) {
          item.style.display = 'flex'
          item.classList.add('search-match')
          categoryMatches++
          matchCount++
          
          // Highlight matching text
          this.highlightText(link, query)
        } else {
          item.style.display = 'none'
          item.classList.remove('search-match')
          this.removeHighlight(link)
        }
      })

      // Show/hide and expand/collapse category based on matches
      if (categoryMatches > 0) {
        category.style.display = 'block'
        category.classList.add('has-matches')
        matchingCategories++
        
        // Update category count to show matches
        const countEl = category.querySelector('.category-count')
        countEl.textContent = `(${categoryMatches} match${categoryMatches !== 1 ? 'es' : ''})`
        
        // Auto-expand matching categories
        if (collapse && !collapse.classList.contains('show')) {
          collapse.classList.add('show')
          if (header) header.classList.remove('collapsed')
        }
      } else {
        category.style.display = 'none'
        category.classList.remove('has-matches')
        
        // Collapse non-matching categories
        if (collapse && collapse.classList.contains('show')) {
          collapse.classList.remove('show')
          if (header) header.classList.add('collapsed')
        }
      }

      this.syncIntakes(category)
    })

    // Update results info
    this.resultsTarget.style.display = 'block'
    this.resultsTextTarget.textContent = `Found ${matchCount} event${matchCount !== 1 ? 's' : ''} in ${matchingCategories} categor${matchingCategories !== 1 ? 'ies' : 'y'}`
    this.countTarget.textContent = matchCount
  }

  highlightText(element, query) {
    const text = element.textContent
    const regex = new RegExp(`(${this.escapeRegex(query)})`, 'gi')
    element.innerHTML = text.replace(regex, '<mark class="search-highlight">$1</mark>')
  }

  removeHighlight(element) {
    element.innerHTML = element.textContent
  }

  escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  }

  clear() {
    this.inputTarget.value = ''
    this.clearTarget.style.display = 'none'
    this.resetSearch()
    this.inputTarget.focus()
  }

  resetSearch() {
    this.resultsTarget.style.display = 'none'
    this.countTarget.textContent = this.totalCount

    this.categoryTargets.forEach(category => {
      category.style.display = 'block'
      category.classList.remove('has-matches')
      
      // Reset category count
      const countEl = category.querySelector('.category-count')
      const items = category.querySelectorAll('.event-item')
      countEl.textContent = `(${items.length})`

      // Show all items and remove highlights
      items.forEach(item => {
        item.style.display = 'flex'
        item.classList.remove('search-match')
        const link = item.querySelector('.event-link')
        this.removeHighlight(link)
      })

      // Collapse all categories
      const collapse = category.querySelector(':scope > .collapse')
      if (collapse && collapse.classList.contains('show')) {
        collapse.classList.remove('show')
        const header = category.querySelector('.evt-category-header')
        if (header) header.classList.add('collapsed')
      }

      this.intakesIn(category).forEach(intake => this.resetIntake(intake))
    })
  }

  syncIntakes(category) {
    this.intakesIn(category).forEach(intake => {
      const items = intake.querySelectorAll('.event-item')
      const visible = Array.from(items).filter(item => item.style.display !== 'none')
      const collapse = intake.querySelector('.collapse')
      const header = intake.querySelector('.evt-intake-header')
      const countEl = intake.querySelector('.evt-intake-count')

      if (visible.length > 0) {
        intake.style.display = ''
        if (countEl) {
          countEl.textContent = `(${visible.length})`
        }
        if (collapse && !collapse.classList.contains('show')) {
          collapse.classList.add('show')
          if (header) header.classList.remove('collapsed')
        }
      } else {
        intake.style.display = 'none'
        if (collapse && collapse.classList.contains('show')) {
          collapse.classList.remove('show')
          if (header) header.classList.add('collapsed')
        }
      }
    })
  }

  resetIntake(intake) {
    intake.style.display = ''
    const items = intake.querySelectorAll('.event-item')
    const countEl = intake.querySelector('.evt-intake-count')
    if (countEl) countEl.textContent = `(${items.length})`

    const collapse = intake.querySelector('.collapse')
    if (collapse && collapse.classList.contains('show')) {
      collapse.classList.remove('show')
    }
    const header = intake.querySelector('.evt-intake-header')
    if (header) header.classList.add('collapsed')
  }

  intakesIn(category) {
    return this.intakeTargets.filter(intake => category.contains(intake))
  }

  // Handle keyboard shortcuts
  keydown(event) {
    // Escape to clear search
    if (event.key === 'Escape') {
      this.clear()
    }
  }
}
